export default "<kt-subheader1 [fluid]=\"fluid\" [clear]=\"clear\"></kt-subheader1>\r\n"